import { usePopper } from 'react-popper'
import InfoIcon from '@mortgage-pos/ui/assets/info-icon.svg'
import React, { FC, useCallback, useState } from 'react'
import { useVariation } from '@mortgage-pos/ui/services/featureFlags'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'

export type Props = {
  title?: string
  text: string
  className?: string
  bodyClass?: string
  positioningStrategy?: 'absolute' | 'fixed'
  placement?: 'top' | 'right' | 'bottom' | 'left'
}

const Tooltip: FC<Props> = ({
  title,
  text,
  className,
  bodyClass,
  positioningStrategy = 'fixed',
  placement = 'bottom',
}: Props) => {
  const [isPopperShown, setShowPopper] = useState(false)
  const [anchorElement, setAnchorElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)

  const { styles, attributes } = usePopper(anchorElement, popperElement, {
    strategy: positioningStrategy,
    placement: placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      },
    ],
  })

  const handleEnter = useCallback(() => setShowPopper(true), [])
  const handleLeave = useCallback(() => setShowPopper(false), [])

  const isBankrate = useVariation(FEATURE_FLAG_TYPES.BANKRATE_COMPARE_ENABLED)

  return (
    <>
      <div
        className={`tooltip__button ${className ? className : ''}`}
        // desktop events
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        // tablet/phone
        onTouchStart={handleEnter}
        onTouchEnd={handleLeave}
        ref={setAnchorElement}
        data-testid="tooltip-button"
      >
        <img
          className={`tooltip__icon ${isBankrate ? '--bankrate' : ''}`}
          src={InfoIcon}
          alt="info icon"
        />
      </div>

      {isPopperShown ? (
        <div
          className={`tooltip__body ${bodyClass ? bodyClass : ''}`}
          ref={setPopperElement}
          style={styles.popper}
          data-testid="tooltip-body"
          {...attributes.popper}
        >
          <div className="tooltip__close-button-wrapper">
            <button
              className="tooltip__close-button"
              onClick={handleLeave}
              data-testid="close-info"
              type="button"
            >
              <i className="fas fa-times" />
            </button>
          </div>
          {title ? <h6 className="tooltip__title">{title}</h6> : null}
          <p className="tooltip__description">{text}</p>
        </div>
      ) : null}
    </>
  )
}

export default Tooltip
